import { Component } from 'solid-js';
import { MeasurementType } from '@trimble/web3d-providers';

export interface SuboptionsIndicatorProps {
  measurementType: MeasurementType;
  onOpenSuboptions(type: MeasurementType): void;
  isLongPressActive?(): boolean;
}

export const SuboptionsIndicator: Component<SuboptionsIndicatorProps> = (
  props
) => {
  const handleClick = (event: MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();

    if (!props.isLongPressActive?.()) {
      props.onOpenSuboptions(props.measurementType);
    }
  };

  return (
    <div
      class={`absolute bottom-[1px] right-[1px] w-[8px] h-[8px] bg-gray-6 cursor-pointer`}
      style={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'clip-path': 'polygon(100% 0%, 0% 100%, 100% 100%)',
      }}
      onClick={handleClick}
    />
  );
};
